import React ,{  useState } from 'react';
import { connect } from 'react-redux';
import { Form } from 'react-bootstrap';
import './radioItems.scss';

const RadioItems = (props) => {

  let options = props.optionsData[props.entry.optionType];
  const getComments = (state) => {
    let comments = {};
    if(props.options) {      
      for(let opt of props.options){
        if(opt.includeComments && opt.commentMapTo){
          comments[opt.commentMapTo] =  state[opt.commentMapTo];
        }
      }
    }
    return comments;

  };

  let comments = getComments(props.stateData);
  if (!props.entry.optionType && props.options) {
    options = props.options;
  }
  let [selectedOption, updateValue] = useState(props.value[props.entry.mapTo] ? props.value[props.entry.mapTo] : { id: null });


  const handleOnChange = (mapTo, option) => {
    updateValue(option);
    props.onChangeHandler(mapTo, option);
  };

  let [valueState, updateTextValue] = useState(props.value[props.entry.otherMapTo]);
  let myChangeHandler = (event) => {
    let mapTo = event.target.name;
    let val = event.target.value;
    updateTextValue(val);
    props.onChangeHandler(mapTo, val);
  };
  let [commentState, updateComment] = useState(comments);
  let commentChangeHandler = (event) => {
    let mapTo = event.target.name;
    let val = event.target.value;
    updateComment({ ...commentState, [mapTo]: val });
    props.onChangeHandler(mapTo, val);
  };

  return (
    <Form.Group style={props.entry.style} className={props.entry.className}
    >
      {props.entry.label ? <Form.Label>{props.entry.label}</Form.Label> : null}
      <div className="radio-items-ctn"  key={`key-${props.entry.type}-${props.entry.mapTo}-ctn`}>
        {options ? options.map((option) => {
          return (
            <React.Fragment key={`fragmentcheckkey-${props.entry.mapTo}-${option.id}`}>
              <Form.Check
                key={`checkkey-${props.entry.mapTo}-${option.id}`}
                name={props.entry.mapTo}
                inline={props.entry.inline}
                label={option.option}
                type={props.entry.type}
                id={`check-${props.entry.type}-${props.entry.mapTo}-${option.id}`}
                checked={selectedOption ? selectedOption.id === option.id : false}
                onChange={() => handleOnChange(props.entry.mapTo, option)}
              />
              {option.subtitle ? <div className='radiobutton-subtitle'>{ option.subtitle} </div> : null}

              { 
                selectedOption?.id === option.id && option.includeComments ? 
                  option.commentsAreRequired ? 
                    <Form.Label>Comments<span className="custom-required">*</span></Form.Label> :
                    <Form.Label>Comments  </Form.Label> : 
                  null
              }

              {
                selectedOption?.id === option.id && option.includeComments ? <Form.Control
                  key={`commentkey-${props.entry.mapTo}-${option.id}`}
                  as="textarea" rows={3}    
                  required={option.commentsAreRequired}
                  name={option.commentMapTo}
                  onChange={commentChangeHandler}
                  isInvalid={option.isInvalid}
                  value={comments[option.commentMapTo]}
                /> : null
              }
              {
                selectedOption?.option === 'Other' && props.entry.includeComments ? <Form.Control
                  type='text'
                  inline={props.entry.inline}
                  className='other-text'
                  style={props.entry.otherTextStyle}
                  name={props.entry.otherMapTo}
                  onChange={myChangeHandler}
                  value={valueState}
                  maxLength={props.entry.maxLength??''}
                /> : null
              }
          </React.Fragment>
          );
        })
          : null}
      </div>

    </Form.Group>
  );
};

const mapStateToProps = function(state) {
  return {
    stateData : state.pagesData.data.basicInformation,
    optionsData : state.options
  };
};


export default connect(mapStateToProps)(RadioItems);